import { type CSSProperties } from "react";

import { spaceHue, monogram } from "../utils/spaceColor";

/**
 * Small rounded monogram chip identifying a space by colour. The hue is the only
 * per-space value; lightness/chroma (and the dark-theme brightness bump) live in
 * the `.space-badge` rule in tokens.css, keyed off the `--space-badge-hue`
 * custom property set here.
 */
export function SpaceBadge({ name }: { name: string }) {
  const style = { "--space-badge-hue": spaceHue(name) } as CSSProperties;
  return (
    <span className="space-badge" style={style}>
      {monogram(name)}
    </span>
  );
}
